import { Link } from 'react-router-dom';

const services = [
  { label: 'Kasetli Tente', href: '/hizmetler/kasetli-tente' },
  { label: 'Körüklü Tente', href: '/hizmetler/koruklu-tente' },
  { label: 'Mafsallı Tente', href: '/hizmetler/mafsalli-tente' },
  { label: 'T Model Tente', href: '/hizmetler/t-model-tente' },
  { label: 'Win Tente', href: '/hizmetler/win-tente' },
  { label: 'Bioklimatik Pergola', href: '/hizmetler/bioklimatik-pergola' },
  { label: 'Otomatik Pergola', href: '/hizmetler/otomatik-pergola' },
  { label: 'Rollingroof Pergola', href: '/hizmetler/rollingroof-pergola' },
  { label: 'Şeffaf Branda', href: '/hizmetler/seffaf-branda' },
  { label: 'Şeffaf Stor Branda', href: '/hizmetler/seffaf-stor-branda' },
  { label: 'Zip Perde', href: '/hizmetler/zip-perde' },
];

const pages = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'SSS', href: '/sss' },
  { label: 'İletişim', href: '/iletisim' },
];

const regions = ['Karşıyaka', 'Bornova', 'Buca', 'Gaziemir', 'Balçova', 'Narlıdere', 'Çiğli', 'Bayraklı', 'Konak', 'Menemen'];

export default function Footer() {
  return (
    <footer className="bg-[#0a1018] text-white">

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/8">

          {/* Brand */}
          <div className="md:col-span-3">
            <Link to="/" className="inline-block mb-6">
              <span className="text-xl md:text-2xl font-extrabold tracking-tight leading-none text-white">İzmir'de <span style={{ color: '#d4a853' }}>Tenteci</span></span>
            </Link>
            <p className="font-body text-sm text-white/40 leading-relaxed mb-6">
              İzmir ve çevre ilçelerde profesyonel tente, pergola ve branda sistemleri. Ücretsiz keşif, uzman montaj.
            </p>
            <div className="flex flex-col gap-2.5">
              <a href="tel:05362771709" className="flex items-center gap-2.5 font-body text-sm text-white/50 hover:text-[#d4a853] transition-colors cursor-pointer">
                <div className="w-7 h-7 flex items-center justify-center bg-[#d4a853]/15 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-[#d4a853] text-xs"></i>
                </div>
                0 (536) 277 17 09
              </a>
              <a href="https://wa.me/905362771709" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center gap-2.5 font-body text-sm text-white/50 hover:text-[#d4a853] transition-colors cursor-pointer">
                <div className="w-7 h-7 flex items-center justify-center bg-[#d4a853]/15 rounded-lg flex-shrink-0">
                  <i className="ri-whatsapp-line text-[#d4a853] text-xs"></i>
                </div>
                WhatsApp
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-4">
            <h4 className="font-body text-xs font-semibold uppercase tracking-widest text-[#d4a853] mb-5">Hizmetlerimiz</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {services.map((s) => (
                <Link key={s.href} to={s.href} className="font-body text-sm text-white/40 hover:text-[#d4a853] transition-colors flex items-center gap-1.5">
                  <span className="w-1 h-1 bg-[#d4a853]/40 rounded-full flex-shrink-0"></span>
                  {s.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Pages */}
          <div className="md:col-span-2">
            <h4 className="font-body text-xs font-semibold uppercase tracking-widest text-[#d4a853] mb-5">Kurumsal</h4>
            <ul className="flex flex-col gap-2">
              {pages.map((p) => (
                <li key={p.href}>
                  <Link to={p.href} className="font-body text-sm text-white/40 hover:text-[#d4a853] transition-colors">{p.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Regions */}
          <div className="md:col-span-3">
            <h4 className="font-body text-xs font-semibold uppercase tracking-widest text-[#d4a853] mb-5">Hizmet Bölgeleri</h4>
            <div className="flex flex-wrap gap-1.5">
              {regions.map((r) => (
                <span key={r} className="font-body text-xs text-white/40 border border-white/10 px-2.5 py-1 rounded-full hover:border-[#d4a853]/40 hover:text-[#d4a853] transition-colors cursor-default">
                  {r}
                </span>
              ))}
            </div>
            <div className="mt-6 bg-[#d4a853]/10 border border-[#d4a853]/20 rounded-xl p-4">
              <p className="font-body text-xs text-white/50 leading-relaxed">
                <span className="text-[#d4a853] font-semibold">İzmir geneli</span> ücretsiz keşif. Tüm ilçelerde aynı kalite.
              </p>
            </div>
          </div>

        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-white/25">© 2026 İzmirde Tenteci. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-4">
            <Link to="/kvkk" className="font-body text-xs text-white/25 hover:text-white/50 transition-colors">KVKK</Link>
            <Link to="/cerez-politikasi" className="font-body text-xs text-white/25 hover:text-white/50 transition-colors">Çerez Politikası</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
